<template>
  <v-container v-if="dataindicador !== null" grid-list-xl>

    <h2 color="primary">{{ dataindicador.codigo }} - {{ dataindicador.nombre }}</h2>
    <br>
    <v-card>
      <v-card-text>
        <label class="v-label primary--text">Información del Indicador</label>

        <v-divider></v-divider>

        <v-layout row wrap>
          <v-flex xs12 md3>
            <label class="v-label primary--text">Periodicidad:</label>
            {{ PeriodicidadSelect }}
          </v-flex>
          <v-flex xs12 md3>
            <label class="v-label primary--text">Rezago:</label>
            {{ dataindicador.diasrezago }}
          </v-flex>
          <v-flex xs12 md3>
            <label class="v-label primary--text">Avance cuatrienio:</label>
            {{ dataindicador.avance }}%
          </v-flex>
          <v-flex xs12 md3>
            <label class="v-label primary--text">Acumulación:</label>
            {{ Tipoacumulacionselect }}
          </v-flex>
          <v-flex xs12 md3>
            <label class="v-label primary--text">Meta cuatrienio:</label>
            {{ dataindicador.meta }}
          </v-flex>
          <v-flex xs12 md3>
            <label class="v-label primary--text">Unidad de medida:</label>
            {{ SelectUnidaddemedida }}
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>

    <div class="vue-contentido">

      <br>
      <v-card :elevation="2">

      <v-card-text>
      <v-tabs next-icon="fa-caret-right" prev-icon="fa-caret-left" icons-and-text show-arrows outlined>
        <v-tabs-slider></v-tabs-slider>
        <v-tab>
          Avances
          <v-icon>mdi-file-alert</v-icon>
        </v-tab>
        <v-tab>
          Historico
          <v-icon>history</v-icon>
        </v-tab>
        <v-tab>
          Ficha técnica
          <v-icon>dialpad</v-icon>
        </v-tab>
        <v-tab>
          Documentos Relacionados
          <v-icon>attach_file</v-icon>
        </v-tab>
        <v-tab-item>
          <v-app>
            <v-layout row wrap>
              <v-flex xs12>
                <v-card :elevation="2" :loading="loading">
                  <v-card-title>Avance cuantitativo</v-card-title>

                  <v-card-text>
                    

                    <v-flex xs12 row>
                      <v-flex xs12 sm12>
                        <p class="font-weight-light">Avances cuantitativos por ingresar..</p>
                        <v-data-table :headers="headeravancecuantitativo"
                          :items="avancecuantitativoA.filter(p => p.idmetaNavigation.valor > 0)" class="elevation-1"
                          :items-per-page="5" :no-data-text="gnodata">

                          <template v-slot:[`item.reporte`]="{ item }">
                            <p v-if="item.reporte != null">{{ item.reporte.toString().replace(".", ",") }}</p>
                          </template>
                          <template v-slot:[`item.idmetaNavigation.valor`]="{ item }">
                            {{ Intl.NumberFormat("es-CO", {
                              maximumFractionDigits: 2
                            }).format(item.idmetaNavigation.valor) }}
                          </template>
                          <template v-slot:top>
                            <v-dialog v-model="dialogAvancCuan" max-width="950px">
                              <v-card>
                                <v-card-title>
                                  {{ avanceCuantitativoedit.rangoperiodo }}
                                </v-card-title>
                                <v-card-text>
                                  
                                  <v-flex xs12 sm12 md12>

                                    <label class="v-label primary--text">Avance cuantitativo.</label>
                                    <v-text-field v-model="avanceCuantitativoedit.reporte"
                                      v-validate="{ decimal: [2, ','] }" data-vv-name="ValorAvancecuantitativo"
                                      :error-messages="errors.collect('ValorAvancecuantitativo')"
                                      outlined
                                      placeholder="Avance cuantitativo"
                                      :disabled="readcontrol('editavancecuantitativo')"
                                      ></v-text-field>

                                  </v-flex>

                                  <label class="v-label primary--text">Anexar soporte de avance cuantitativo.</label>
                                  <v-container row>
                                    <v-flex v-show="false">
                                      <span class="primary--text ">Periodo</span>
                                      <v-select :items="avancecuantitativoA.filter(p => p.idmetaNavigation.valor > 0)"
                                        v-model="selectedcuantitativo" item-text="rangoperiodo"
                                        item-value="idavancecuantitativo" 
                                        v-show="showcontrol('agregarsoportecuantitativo')"
                                        outlined
                                        placeholder="Periodo"
                                        ></v-select>
                                    </v-flex>

                                    <v-flex sm12 md7>
                                      <template>
                                        <v-file-input accept=".pdf, .xlsx, .xls" v-model="filecuantitativo" show-size
                                          multiple label="cargar archivo"
                                          v-show="showcontrol('agregarsoportecuantitativo')"
                                          @change="onSoporteCuanChange"
                                          placeholder="Archivo"
                                          outlined
                                          class="mr-2"
                                          ></v-file-input>
                                      </template>
                                    </v-flex>

                                    <v-flex sm6 md3 style="align-self: center;">
                                      <v-checkbox v-model="cuantitativopublico" label="Privado" class="mr-2"
                                        v-show="showcontrol('soportepublico')"></v-checkbox>
                                    </v-flex>

                                    <v-flex sm6 md2 style="align-self: center;">
                                      <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                          <v-btn outlined v-on="on" class="ma-2" @click="Addsoportecuantitativo"
                                            :disabled="readcontrol('agregarsoportecuantitativo')" tile
                                            v-show="showcontrol('agregarsoportecuantitativo')" color="success">
                                            <v-icon left>add</v-icon>Anexar soporte
                                          </v-btn>
                                        </template>
                                        <span>Agregar archivo</span>
                                      </v-tooltip>
                                    </v-flex>

                                  </v-container>

                                  <v-flex>

                                    <v-expansion-panels>
                                      <v-expansion-panel :accordion="false" :inset="true" :focusable="true">
                                        <v-expansion-panel-header>
                                          <p class="font-weight-light">Lista de archivos avance cuantitativo.</p>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                          <v-card color="#EEEEEE">
                                            <v-data-table 
                                                :headers="HeaderListsoportecuantitativo" 
                                                :items="soportescuanti.filter(X => X.idavancecuantitativo == selectedcuantitativo || X.idavance ==  selectedcuantitativo)"
                                                class="elevation-1" 
                                                :no-data-text="gnodata"
                                                hide-default-header hide-default-footer>
                                                </v-data-table>  
                                          </v-card>
                                        </v-expansion-panel-content>
                                      </v-expansion-panel>
                                    </v-expansion-panels>



                                  
                                  </v-flex>
                                


                                </v-card-text>
                                <v-card-actions>
                                  <v-btn color="blue darken-1" @click="closedialog">Cancelar</v-btn>
                                  <v-btn color="blue darken-1" @click="saveCuantitativo" :disabled="readcontrol('editavancecuantitativo')">Guardar</v-btn>
                                </v-card-actions>
                              </v-card>
                            </v-dialog>
                          </template>
                          <template v-slot:[`item.action`]="{ item }">
                            <v-layout row wrap>
                              <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                  <v-icon v-on="on" small class="mr-2" @click="editItemavancecuantitativo(item)"
                                    >edit</v-icon>
                                </template>
                                <span>Registrar</span>
                              </v-tooltip>
                              <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                  <v-checkbox v-model="item.marcarExcluir" v-on="on"
                                    v-if="currentRol.findIndex(x => x == 3) !== -1"></v-checkbox>
                                </template>
                                <span>Excluir registro</span>
                              </v-tooltip>
                            </v-layout>

                          </template>
                        </v-data-table>
                        <v-alert v-if="currentRol.findIndex(x => x == 3) !== -1" border="left" colored-border dense
                          color="blue darken-1" elevation="2" dismissible type="info">
                          <p class="font-weight-light">La opción excluir registro solo aplica al enviar el formulario, si
                            guarda los cambios y cierra, no se guardarán los registros marcados como excluidos.</p>
                        </v-alert>

                      </v-flex>

                      <v-flex xs12 sm12>

                        <v-expansion-panels>
                          <v-expansion-panel :accordion="false" :inset="true" :focusable="true">
                            <v-expansion-panel-header>
                              <p class="font-weight-light">Registros del avance cuantitativo aprobados:::</p>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <v-card :disabled="true" color="#EEEEEE">
                                <v-data-table :headers="headeravancecuantitativohistoric"
                                  :items="ancecuantitativohistoricA" :items-per-page="100" hide-default-footer
                                  :no-data-text="gnodata" class="elevation-0"></v-data-table>
                              </v-card>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>

                        <v-expansion-panels>
                          <v-expansion-panel :accordion="false" :inset="true" :focusable="true">
                            <v-expansion-panel-header>
                              <p class="font-weight-light">Ver archivos avance cuantitativo.</p>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <v-card color="#EEEEEE">
                                <v-data-table :headers="showHeadersSCunatitativo" :items="soportescuanti"
                                  class="elevation-1" :items-per-page="100" hide-default-footer :no-data-text="gnodata">
                                  <template v-slot:[`item.publico`]="{ item }">
                                    <div v-show="item.publico == false">
                                      <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                          <v-icon v-on="on" small class="mr-2">fa-solid fa-lock</v-icon>
                                        </template>
                                        <span>Documento privado</span>
                                      </v-tooltip>
                                    </div>
                                  </template>
                                  <template v-slot:[`item.action`]="{ item }">
                                    <v-tooltip top>
                                      <template v-slot:activator="{ on }">
                                        <v-icon v-on="on" small class="mr-2" @click="deletesoportecuantitativo(item)"
                                          :disabled="readcontrol('eliminarsoortecuantitativo')">delete</v-icon>
                                      </template>
                                      <span>Eliminar</span>
                                    </v-tooltip>
                                    <v-tooltip top>
                                      <template v-slot:activator="{ on }">
                                        <v-icon v-on="on" small class="mr-2"
                                          @click="descargarsoporte(item)">mdi-file</v-icon>
                                      </template>
                                      <span>Descargar</span>
                                    </v-tooltip>

                                    <v-tooltip top v-if="showcontrol('soportepublico')">
                                      <template v-slot:activator="{ on }">
                                        <v-icon v-on="on" small class="mr-2"
                                          @click="changestatesoporte(item)">edit</v-icon>
                                      </template>
                                      <span>Cambiar privacidad</span>
                                    </v-tooltip>

                                  </template>
                                </v-data-table>
                              </v-card>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </v-flex>
                    </v-flex>
                    
                  </v-card-text>
                </v-card>
              </v-flex>

              <v-flex xs12>
                <v-card :elevation="2" :loading="loading" :disabled="loading">
                  <v-card-title>Avance cualitativo</v-card-title>
                  <v-card-text active-class="deep-purple accent-4 white--text">
                    <v-flex xs12 sm12>
                      <p class="font-weight-light">Avances cualitativos por ingresar-</p>
                      <v-data-table :headers="headeravancecualitativo" :items="gavancecualitativo" class="elevation-1"
                        :no-data-text="gnodata" :items-per-page="5">
                        <template v-slot:top>
                          <v-dialog v-model="dialogAvancCual" fullscreen>
                            <v-card>
                              <v-toolbar dark color="primary">
                                <v-btn icon dark @click="closedialog">
                                  <v-icon>mdi-close</v-icon>
                                </v-btn>
                                <v-toolbar-title>{{ avanceCualitativoedit.rangoperiodo }}</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-toolbar-items>
                                  <v-btn variant="text" @click="saveCualitativo" color="blue darken-1" :disabled="readcontrol('editavancecualitativo')">
                                    Guardar
                                  </v-btn>
                                </v-toolbar-items>
                              </v-toolbar>


                              <v-card-text>
                                <br>

                                <v-card flat :elevation="2" v-show="avanceCualitativoedit.nuevoscampos == true" >
                                  <v-card-text>
                                    <br>
                                    <label class="v-label primary--text" >Avance Cualitativo</label>
                                    <v-divider></v-divider>
                                    <br>                                    
                                    <v-layout row wrap>
                                      <v-flex xs12 sm6 md6>
                                        <v-label class="font-weight-light">
                                          Describa los principales avances en función del cumplimiento de la meta del indicador
                                          </v-label>
                                      </v-flex>
                                      <v-flex xs12 sm6 md6>
                                        <v-label>
                                          Identifique y explique los principales cuellos de botella y limitaciones que afectaron el desempeño del indicador
                                        </v-label>
                                      </v-flex>
                                      <v-flex xs12 sm6 md6>
                                        

                                      <v-textarea outlined rows="3" class="mr-2"
                                      v-model="avanceCualitativoedit.principalavance"
                                      placeholder="Da cuenta del avance del indicador de manera puntual, clara y detallada, describiendo los principales factores que aportaron al cumplimiento de las metas durante el periodo reportado (300 caracteres)"
                                          :counter="300"
                                          :readonly="readcontrol('editavancecualitativo')"
                                          ></v-textarea>

                                      </v-flex>
                                      <v-flex xs12 sm6 md6>
                                        <v-textarea class="mr-2" outlined rows="3" :counter="300"
                                        v-model="avanceCualitativoedit.cuellobotella"
                                        placeholder="En caso de no aplicar, por favor diligenciar con: 'No se identifican cuellos de botella y limitaciones en el periodo'. (300 caracteres)"
                                        :readonly="readcontrol('editavancecualitativo')"
                                        ></v-textarea>
                                      </v-flex>
                                    </v-layout>
                                  </v-card-text>
                                </v-card>
                                <br>
                                
                                <v-card flat :elevation="2" v-show="avanceCualitativoedit.nuevoscampos == true">
                                  <v-card-text>
                                    <label class="v-label primary--text">Restricciones.</label>
                                    <v-divider></v-divider>
                                    <br>                                    
                                    <v-layout row>
                                      <v-flex sm12 md8>
                                        <v-label class="font-weight-light">
                                          ¿El indicador tiene restricciones que afectaron su desempeño? (marque máximo 2)
                                        </v-label>

                                        <v-select 
                                          :items="greestricciones" 
                                          v-model="selectedrestricciones"
                                          item-text="nombre" item-value="idreestriccion"
                                          multiple clearable
                                          placeholder="Restricciones" outlined class="mr-2"
                                          :rules="maxlength" 
                                          :disabled="readcontrol('editavancecualitativo')"  
                                        ></v-select>
                                      </v-flex>
                                      <v-flex sm12 md4>
                                        <v-label class="font-weight-light">Otra restricción.</v-label>
                                        <v-text-field 
                                        :disabled="!shownewrestriccion || readcontrol('editavancecualitativo')"
                                        v-model="avanceCualitativoedit.nuevareestriccion"
                                        class="mr-2" outlined placeholder="Nombre de la reestricción"
                                        ></v-text-field>
                                      </v-flex>
                                    </v-layout>
                                  </v-card-text>
                                </v-card>


                                <br>

                                
                              
                                <v-card flat :elevation="2">
                                  <v-card-text>
                                    <v-layout row>
                                      <v-flex sm12 md12>
                                        <label class="v-label primary--text">Justificación del avance</label>

                                        <quill-editor class="mr-2" ref="avancecualitativo" id="avancecualitativo"
                                          v-model="avanceCualitativoedit.descripcion" data-vv-name="ValorAvanceCualiativo"
                                          :error-messages="errors.collect('ValorAvanceCualiativo')"
                                          :options="editorOptionsAvanceCualitativo" @ready="onEditorReady($event)"
                                          @change="onEditorChange($event)" outlined
                                          :disabled="readcontrol('editavancecualitativo')"
                                          />
                                        <div id="counter" class="counter"></div>
                                      </v-flex>                                                                          
                                    </v-layout>
                                  </v-card-text>
                                </v-card>
<br>





                                <label class="v-label primary--text">Anexar soporte de avance cualitativo.</label>
                                <v-divider></v-divider>
                                <br>
                                <v-card flat :elevation="2">
                                  <v-card-text>
                                    <v-flex row>
                                      <v-flex v-show="false">
                                        <v-select :items="gavancecualitativo" v-model="selectedcualitativo"
                                          item-text="rangoperiodo" item-value="idavancecualitativo"
                                          placeholder="Seleccione el avance cualitativo"
                                          v-show="showcontrol('agregarsoportecualitativo')"
                                          outlined class="mr-2"></v-select>
                                      </v-flex>
                                      <v-flex sm12 md7>
                                        <template>
                                          <v-file-input accept=".pdf, .xlsx, .xls" v-model="filecualitativo" show-size
                                          placeholder="Cargar archivo" multiple
                                            v-show="showcontrol('agregarsoportecualitativo')"
                                            @change="onSoporteCualChange"
                                            outlined class="mr-2"></v-file-input>
                                        </template>
                                      </v-flex>
                                      <v-flex sm6 md3 style="align-self: center;">
                                        <v-checkbox v-model="cualitativopublico" label="Privado" outlined
                                          v-show="showcontrol('soportepublico')" class="mr-2"
                                          ></v-checkbox>
                                      </v-flex>
                                      <v-flex sm6 md2>
                                        <v-tooltip top>
                                          <template v-slot:activator="{ on }">
                                            <v-btn v-on="on" class="ma-2" @click="Addsoportecualitativo"
                                              :disabled="readcontrol('agregarsoportecualitativo')"
                                              v-show="showcontrol('agregarsoportecualitativo')" tile outlined
                                              color="success">
                                              <v-icon left>add</v-icon>Anexar soporte
                                            </v-btn>
                                          </template>
                                          <span>Agregar archivo</span>
                                        </v-tooltip>
                                      </v-flex>
                                    </v-flex>

                                    <v-expansion-panels>
                                      <v-expansion-panel :accordion="false" :inset="true" :focusable="true">
                                        <v-expansion-panel-header>
                                          <p class="font-weight-light">Lista de archivos avance cualitativo.</p>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                          <v-card color="#EEEEEE">
                                            <v-data-table 
                                                :headers="HeaderListsoportecuantitativo" 
                                                :items="soportescuali.filter(X => X.idavancecualitativo == selectedcualitativo || X.idavance ==  selectedcualitativo)"
                                                class="elevation-1" 
                                                :no-data-text="gnodata"
                                                hide-default-header hide-default-footer>
                                                </v-data-table>  
                                          </v-card>
                                        </v-expansion-panel-content>
                                      </v-expansion-panel>
                                    </v-expansion-panels>



                                  </v-card-text>
                                </v-card>

                                <div v-show="gTipovalorListadesagregacion.length > 0 && avanceCualitativoedit.mostrardesagregaciones">
                                  <label class="v-label primary--text">Reporte de avance con desagregaciones territorial y poblacional - diferencial</label>
                                  <v-divider></v-divider>
                                </div>

                                <br>
                                <v-card flat :elevation="2" v-show="gTipovalorListadesagregacion.length > 0 && avanceCualitativoedit.mostrardesagregaciones">
                                  <v-card-text :readonly="readcontrol('desagregaciones')">
                                    <!-- Tu código existente aquí -->

                                    <div v-if="avanceCualitativoedit.mostrardesagregaciones" >
                                          <v-expansion-panels class="mb-6" v-model="panel">
                                            <v-expansion-panel
                                              v-for="(item, i) in tiposValores" :key="i">
                                              <v-expansion-panel-header disable-icon-rotate expand-icon="mdi-menu-down">
                                                <div style="display: flex;">
                                                  <div style="width: 100px;">
                                                    <!-- Div1 content here -->
                                                    <template>
                                                      <div v-if="avanceCualitativoedit.avanceCualitativoTipoValores.filter(p => p.idtipovalor === item.id ).length > 0">
                                                        <v-icon v-if="avanceCualitativoedit.avanceCualitativoTipoValores.filter(p => p.idtipovalor === item.id )[0].cargado  === true " color="green" >mdi-check</v-icon>
                                                        <v-icon v-else color="orange">mdi-exclamation</v-icon>
                                                      </div>
                                                    </template>
                                                  </div>
                                                  <div style="flex-grow: 1;">
                                                    <!-- Div2 content here -->
                                                    {{ item.nombre }}
                                                  </div>
                                                </div>

                                              </v-expansion-panel-header>
                                              <v-expansion-panel-content v-if="avanceCualitativoedit.avanceCualitativoTipoValores.filter(p => p.idtipovalor === item.id ).length > 0">
                                                <excel_upload @archivo-cargado="handleArchivoCargado" :codigoIndicador="dataindicador.codigo" :estadoCarga="avanceCualitativoedit.avanceCualitativoTipoValores.filter(p => p.idtipovalor === item.id )[0].cargado" :nombreIndicador="dataindicador.nombre"  :idindicador="avanceCualitativoedit.idindicador" :rangoperiodo="avanceCualitativoedit.rangoperiodo" :idtipovalor="item.id" :deshabilitado="readcontrol('desagregaciones')" :idavancecualitativo="avanceCualitativoedit.idavancecualitativo" :idavctp="avanceCualitativoedit.avanceCualitativoTipoValores.filter(p => p.idtipovalor === item.id )[0].idavancecualitativotipovalor"></excel_upload>
                                              </v-expansion-panel-content>
                                            </v-expansion-panel>
                                          </v-expansion-panels>
                                        </div>

                                  </v-card-text>
                                </v-card>

                              </v-card-text>

                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:[`item.descripcion`]="{ item }">
                          <div v-html="cambiarenter(item.descripcion)"></div>
                        </template>
                        <template v-slot:[`item.action`]="{ item }">
                          <v-layout row wrap>
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-icon v-on="on" small class="mr-2" @click="editItemavancecualitativo(item)"
                                  >edit</v-icon>
                              </template>
                              <span>Registrar</span>
                            </v-tooltip>

                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-checkbox v-model="item.marcarExcluir" v-on="on"
                                  v-if="currentRol.findIndex(x => x == 3) !== -1"></v-checkbox>
                              </template>
                              <span>Excluir registro</span>
                            </v-tooltip>
                          </v-layout>

                        </template>
                      </v-data-table>
                      <v-alert v-if="currentRol.findIndex(x => x == 3) !== -1" border="left" colored-border dense
                        color="blue darken-1" elevation="2" dismissible type="info">
                        <p class="font-weight-light">La opción excluir registro solo aplica al enviar el formulario, si
                          guarda los cambios y cierra, no se guardarán los registros marcados como excluidos.</p>
                      </v-alert>

                    </v-flex>

                    <v-flex xs12 sm12>
                      <v-expansion-panels>
                        <v-expansion-panel :accordion="false" :inset="true" :focusable="true">
                          <v-expansion-panel-header>
                            <p class="font-weight-light">Registros del avance cualitativo aprobados.</p>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <v-card :disabled="true" color="#EEEEEE">
                              <v-data-table :no-data-text="gnodata" :headers="headeravancecualitativohistoric"
                                :items="gavancecualitativohistoric" :items-per-page="100" class="elevation-0"
                                hide-default-footer>
                                <template v-slot:[`item.descripcion`]="{ item }">
                                  <div v-html="cambiarenter(item.descripcion)"></div>
                                </template>
                              </v-data-table>
                            </v-card>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                      <v-expansion-panels>
                        <v-expansion-panel :accordion="false" :inset="true" :focusable="true">
                          <v-expansion-panel-header>
                            <p class="font-weight-light mx-2">Ver archivos avance cualitativo.</p>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <v-data-table :headers="showHeadersSCunatitativo" :items="soportescuali" class="elevation-1"
                              :items-per-page="100" hide-default-footer :no-data-text="gnodata">
                              <template v-slot:[`item.publico`]="{ item }">
                                <div v-show="item.publico == false">
                                  <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                      <v-icon v-on="on" small class="mr-2">fa-solid fa-lock</v-icon>
                                    </template>
                                    <span>Documento privado</span>
                                  </v-tooltip>
                                </div>
                              </template>

                              <template v-slot:[`item.action`]="{ item }">
                                <v-tooltip top>
                                  <template v-slot:activator="{ on }">
                                    <v-icon v-on="on" small class="mr-2" @click="deletesoportecualitativo(item)"
                                      :disabled="readcontrol('eliminarsoortecualitativo')">delete</v-icon>
                                  </template>
                                  <span>Eliminar</span>
                                </v-tooltip>
                                <v-tooltip top>
                                  <template v-slot:activator="{ on }">
                                    <v-icon v-on="on" small class="mr-2" @click="descargarsoporte(item)">mdi-file</v-icon>
                                  </template>
                                  <span>Descargar</span>
                                </v-tooltip>

                                <v-tooltip top v-if="showcontrol('soportepublico')">
                                  <template v-slot:activator="{ on }">
                                    <v-icon v-on="on" small class="mr-2" @click="changestatesoporte(item)">edit</v-icon>
                                  </template>
                                  <span>Cambiar privacidad</span>
                                </v-tooltip>

                              </template>
                            </v-data-table>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-flex>
                  </v-card-text>
                </v-card>
              </v-flex>

              <v-speed-dial fixed :top="false" :bottom="true" :right="true" :left="false" direction="left"
                :open-on-hover="true" transition="scale-transition">
                <template v-slot:activator>
                  <v-btn fab color="blue-grey lighten-3">
                    <v-icon>add</v-icon>
                  </v-btn>
                </template>
                <v-btn fab dark small color="green" @click="SaveAvance" v-show="!buttonguardarestado">
                  <v-icon>save</v-icon>
                </v-btn>
                <v-btn fab dark small color="green" @click="FinalizarAvance" v-show="!buttonfinalizarestado">
                  <v-icon>send</v-icon>
                </v-btn>
              </v-speed-dial>
            </v-layout>
          </v-app>
        </v-tab-item>
        <v-tab-item>
          <historico :idtabla="4" :idelemento="dataindicador.idindicador"></historico>
        </v-tab-item>
        <v-tab-item>
          <detalleindicador :getidIndicador="dataindicador.idindicador" />
        </v-tab-item>
        <v-tab-item>
          <v-card>
            <v-card-title>
              <p v-if="dataindicador">{{ dataindicador.codigo }} {{ dataindicador.nombre }}</p>
            </v-card-title>
          </v-card>
          <v-card>
            <v-card-title class="grey lighten-4 change-font">Soportes - Avance cuantitativo</v-card-title>

            <v-card-text>
              <br />
              <v-data-table :headers="headersoportecuantitativo" :items="gsoportescuantitativosaprobados"
                class="elevation-1" :items-per-page="5" :no-data-text="gnodata">
                <template v-slot:[`item.fechacreacion`]="{ item }">{{ formato(item.fechacreacion) }}</template>
                <template v-slot:[`item.fechacorte`]="{ item }">{{ formatobasic(item.fechacorte) }}</template>
                <template v-slot:[`item.publico`]="{ item }">
                  <div v-show="item.publico == false">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on" small class="mr-2">fa-solid fa-lock</v-icon>
                      </template>
                      <span>Documento privado</span>
                    </v-tooltip>
                  </div>
                </template>
                <template v-slot:[`item.action`]="{ item }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on" small class="mr-2" @click="descargarsoporte(item)">mdi-file</v-icon>
                    </template>
                    <span>Descargar</span>
                  </v-tooltip>
                </template>
              </v-data-table>


            </v-card-text>
          </v-card>

          <v-card>
            <v-card-title class="grey lighten-4 change-font">Soportes - Avance cualitativo</v-card-title>

            <v-card-text>
              <br />
              <v-data-table :headers="headersoportecualitativo" :items="gsoportescualitativosaprobados"
                class="elevation-1" :items-per-page="5" :no-data-text="gnodata">
                <template v-slot:[`item.fechacreacion`]="{ item }">{{ formato(item.fechacreacion) }}</template>
                <template v-slot:[`item.fechacorte`]="{ item }">{{ formatobasic(item.fechacorte) }}</template>
                <template v-slot:[`item.publico`]="{ item }">
                  <div v-show="item.publico == false">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on" small class="mr-2">fa-solid fa-lock</v-icon>
                      </template>
                      <span>Documento privado</span>
                    </v-tooltip>
                  </div>
                </template>
                <template v-slot:[`item.action`]="{ item }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on" small class="mr-2" @click="descargarsoporte(item)">mdi-file</v-icon>
                    </template>
                    <span>Descargar</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>

          <v-card>
            <v-card-title class="grey lighten-4 change-font">Soportes - Hito</v-card-title>

            <v-card-text>
              <br />
              <v-data-table :headers="headersoporte" :items="gsoportehitoaprobados" class="elevation-1"
                :items-per-page="5" :no-data-text="gnodata">
                <template v-slot:[`item.fechacreacion`]="{ item }">{{ formato(item.fechacreacion) }}</template>
                <template v-slot:[`item.action`]="{ item }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on" small class="mr-2" @click="descargarsoporte(item)">mdi-file</v-icon>
                    </template>
                    <span>Descargar</span>
                  </v-tooltip>
                </template>
              </v-data-table>

            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
      <v-flex>
                                        <v-card-text>
                                          <v-alert text elevation="2" border="left" color="primary" type="info" dismissible >
                                            Recuerde que la información cargada es de carácter público, por lo tanto no se debe cargar información clasificada, reservada (Ley 1712 de 2014) y/o con datos personales (Ley 1581 de 2012).
                                          </v-alert>
                                        </v-card-text>
                                      </v-flex>
    </v-card-text>
    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary"  @click="SaveAvance" :disabled="buttonguardarestado"> GUARDAR AVANCE  <v-icon color="white" class="ma-2">fa-regular fa-save</v-icon> </v-btn>
                    <v-btn color="success"  @click="FinalizarAvance" :disabled="buttonfinalizarestado">  ENVIAR AVANCE <v-icon class="ma-2">fa-solid fa-paper-plane</v-icon> </v-btn>
                  </v-card-actions>
    </v-card>
      <v-divider></v-divider>

      <v-flex xs12 sm12 v-show="controlrevision('comentarioflujo')">
        <v-card tile :loading="loading">
          <v-toolbar flat dark color="primary">
            <v-toolbar-title>Revisión del Indicador ({{ dataindicador.codigo }})</v-toolbar-title>
            <div class="flex-grow-1"></div>
          </v-toolbar>
          <v-card-text>
            <v-flex xs12 sm12>
              <!-- <v-textarea
                v-validate="'max:4000'"
                data-vv-name="revisioncomentario"
                :error-messages="errors.collect('revisioncomentario')"
                :counter="4000"
                v-model="dataindicador.comentarioflujo"
                label="Comentario:"
                :disabled="readcontrol('comentarioflujo')"
              ></v-textarea> -->
              <label for="avancecualitativo" class="form-label">Comentario:</label>
              <quill-editor ref="revisioncomentario" id="revisioncomentario" v-model="dataindicador.comentarioflujo"
                label="Comentario:" :disabled="readcontrol('comentarioflujo') == true"
                :options="editorOptionsRevisionComentario" @ready="onEditorReady($event)"
                @change="onEditorChange($event)" />
              <div id="counter2" class="counter"></div>
            </v-flex>
            <v-flex row>
              <v-flex xs6 sm6></v-flex>
              <v-flex xs6 sm6>
                <v-select :items="dropdown_comment" v-model="dataindicador.fichaaprobada" item-text="text"
                  item-value="value" label="Seleccione opción" :disabled="readcontrol('comentarioflujo')"></v-select>
              </v-flex>
            </v-flex>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-snackbar v-model="snack" :timeout="timeoutsnak" :color="MesaggeInfo.color">
        {{ this.MesaggeInfo.codigoRespuesta }}
        {{ this.MesaggeInfo.mensajeRespuesta }}
        <v-btn text @click="functionalert">{{ buttontext }}</v-btn>
      </v-snackbar>
    </div>
  </v-container>
</template>

<script>
import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
import store from "../../stores/index.js";
import moment, { relativeTimeThreshold } from "moment";
import historico from "../../components/content/historico";
import detalleindicador from "../../components/content/detalleindicador.vue";
import excel_upload from "@/components/content/desagregacion";
import { ErrorBag } from 'vee-validate';
import 'quill/dist/quill.core.css' // import styles
import 'quill/dist/quill.snow.css' // for snow theme
import { quillEditor } from 'vue-quill-editor';
import Counter from "../../components/global/counter.js";
import Quill from 'quill';
var Delta = Quill.import('delta');
Quill.register('modules/counter', Counter);

export default {
  name: "reporteavances",
  data() {
    return {
      //campos default
      panel: null,
      tiposValores: [],
      loading: false,
      currentRol: [],
      estadocampos: [],
      estadocamposindicador: [],
      buttonguardarestado: true,
      buttonfinalizarestado: true,
      buttonrevision: true,
      usuarioregistrado: [],
      soportescuanti: [],
      soportescuali: [],
      userautenticado: false,
      idindicador: null,
      cargandocuali: false,
      cargandocuanti: false,
      tamanoarchivo: null,
      tamanopaquete: null,
      tiposarchivo: null,
      estadoindicador: "",
      PeriodicidadSelect: "",
      Tipoacumulacionselect: "",
      SelectUnidaddemedida: "",
      selectedrestricciones:[],
      shownewrestriccion: false,
      maxlength: [v => v.length <= 2 || "Solo se permiten 2 restricciones"],
      dropdown_comment: [
        { text: "Aprobar", value: true },
        { text: "Rechazar", value: false }
      ],
      estadoRegistro: 0,

      //campos de la tabla de avance cualitativo
      dataindicador: null,
      headeravancecualitativo: [
        {
          text: "Periodo a Reportar",
          value: "rangoperiodo",
          align: "center",
          width: 200
        },
        { text: "Avance cualitativo", value: "descripcion", align: "left" },
        { text: "Acciones", value: "action", sortable: false }
      ],
      headersoportecualitativo: [
        { text: "Nombre archivo", value: "nombrearchivo", align: "center", width: "30%" },
        { text: "Fecha de carga", value: "fechacreacion", align: "left" },
        { text: "Avance", value: "rangosoporte", align: "left" },
        { text: "Corte", value: "fechacorte", align: "left", width: 100 },
        { text: "Privado", value: "publico", align: "left" },
        { text: "Acciones", value: "action", sortable: false }
      ],
      headeravancecualitativohistoric: [
        {
          text: "Periodo Reportado",
          value: "rangoperiodo",
          align: "center",
          width: 200
        },
        { text: "Avance cualitativo", value: "descripcion", align: "left" }
      ],
      headersoporte: [
        { text: "Nombre archivo", value: "nombrearchivo", align: "left" },
        { text: "Fecha de carga", value: "fechacreacion", align: "left" },
        {
          text: "Cumplimiento",
          value: "rangosoporte",
          align: "center",
          width: 200
        },
        { text: "Acciones", value: "action", sortable: false, width: 130 }
      ],
      cualitativopublico: false,
      soportecualitativo: {
        nombrearchivo: "",
        tipoarchivo: "",
        idavance: 0,
        archivocompleto: "",
        rangosoporte: "",
        publico: false,
        filefull: []
      },
      dialogAvancCual: false,
      dialogSportCual: false,
      avanceCualitativoedit: { descripcion: "" },
      editedIndexcualitativo: -1,
      selectedcualitativo: 0,
      filecualitativo: null,
      imageUrlcualitativo: null,
      deletesoporteCualitativo: [],
      avancecuantitativoA: [],
      ancecuantitativohistoricA: [],

      //campos de la tabla avance cuantitativo
      headeravancecuantitativo: [
        { text: "Meta", value: "idmetaNavigation.valor", align: "center" },
        { text: "Periodo a Reportar", value: "rangoperiodo", align: "center" },
        { text: "Avance cuantitativo", value: "reporte", align: "center" },
        { text: "Acciones", value: "action", sortable: false }
      ],

      headersoportecuantitativo: [
        { text: "Nombre archivo", value: "nombrearchivo", align: "center", width: "30%" },
        { text: "Fecha de carga", value: "fechacreacion", align: "left" },
        { text: "Avance", value: "rangosoporte", align: "left" },
        { text: "Corte", value: "fechacorte", align: "left" },
        { text: "Privado", value: "publico", align: "center" },
        { text: "Acciones", value: "action", sortable: false }
      ],
      HeaderListsoportecuantitativo: [
        { text: "Nombre archivo", value: "nombrearchivo", align: "left", width: "30%" },
      ],      
      headeravancecuantitativohistoric: [
        { text: "Meta", value: "idmetaNavigation.valor", align: "center" },
        { text: "Periodo Reportado", value: "rangoperiodo", align: "center" },
        { text: "Avance cuantitativo", value: "reporte", align: "center" }
      ],
      cuantitativopublico: false,
      soportecuantitativo: {
        nombrearchivo: "",
        tipoarchivo: "",
        idavance: 0,
        archivocompleto: "",
        publico: false,
        filefull: []
      },
      dialogAvancCuan: false,
      avanceCuantitativoedit: { valor: 0 },
      editedIndexcuantitativo: -1,
      selectedcuantitativo: 0,
      filecuantitativo: null,
      imageUrlcuantitativo: null,
      deletesoporteCuantitativo: [],

      //campos del cuadro de dialog de mensajes
      snack: false,
      MesaggeInfo: [{ codigoRespuesta: "", color: "", mensajeRespuesta: "" }],
      timeoutsnak: 6000,
      buttontext: "cerrar",

      //campos de las validacionde de los campos
      dictionary: {
        custom: {
          ValorAvanceCualiativo: {
            required: () => "El campo descripcion no puede estar en blanco",
            max: "esta superando el limite de caracteres"
          },
          ValorAvancecuantitativo: {
            decimal: "solo numeros con el siguiente formato (.##) "
          },
          revisioncomentario: {
            required: () => "el comentario no puede estar en blanco",
            max: "esta superando el limite de caracteres"
          }
        }
      },
      reglasarchivocarga: [
        value => !value || "El archivo no puede ser mayor a 5 megas!"
      ],

      //plantillas footer data-tables soportecuantitativo
      pageCountSopCuan: 0,
      pageSopCuan: 1,
      itemsPerPageSopCuan: 5,


      //plantillas footer data-tables soportecuantitativo
      pageCountSopCual: 0,
      pageSopCual: 1,
      itemsPerPageSopCual: 5,


      //validacion de idsfinalizados
      timewait: 3,
      AvanceFiltrado: [],
      quill: null,
      editorOptionsAvanceCualitativo: {
        theme: 'snow',
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'],
              [{ list: 'ordered' }, { list: 'bullet' }],
              [{ 'indent': '-1' }, { 'indent': '+1' }],
            ],
          },
          counter: {
            container: '#counter',
            controlContainer: '#avancecualitativo',
            unit: 'letra',
            max: 4000
          }
          ,
          clipboard: {
            matchVisual: false,
            matchers: [
              [Node.ELEMENT_NODE, function (node, delta) {
                return delta.compose(new Delta().retain(delta.length(),
                  {
                    align: "justify",
                    link: false,
                    color: false,
                    size: "10px",
                    header: false
                  }
                ));
              }
              ]
            ]
          }
        },
        placeholder: ''
      },
      editorOptionsRevisionComentario: {
        theme: 'snow',
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'],
              [{ list: 'ordered' }, { list: 'bullet' }],
              [{ 'indent': '-1' }, { 'indent': '+1' }],
            ],
          },
          counter: {
            container: '#counter2',
            controlContainer: '#revisioncomentario',
            unit: 'letra',
            max: 8000
          },
          clipboard: {
            matchVisual: false,
            matchers: [
              [Node.ELEMENT_NODE, function (node, delta) {
                return delta.compose(new Delta().retain(delta.length(),
                  {
                    align: "justify",
                    link: false,
                    color: false,
                    size: "10px",
                    header: false
                  }
                ));
              }
              ]
            ]
          }
        },
        placeholder: ''
      }
    };
  },
  components: {
    historico,
    detalleindicador,
    quillEditor,
    excel_upload
  },
  $_veeValidate: {
    validator: "new"
  },
  mounted() {
    this.$validator.localize("es", this.dictionary);
  },
  methods: {
    ...mapActions([
      "getavancecualitativo",
      "getcualitativohistorico",
      "Indicador_avances",
      "getavancecuantitativo",
      "getcuantitativohistorico",
      "getsoportescuantitativos",
      "getsoportescualitativos",
      "putavance",
      "set_information",
      "get_camposestado",
      "get_camposestadosecundary",
      "downloadsoporte",
      "get_historicotareas",
      "get_configuraciones",
      "getsoportesHitosbyind",
      "getcambiarestadosoporte",
      "Getperiodicidad",
      "Gettipoacumulacion",
      "get_unidades",
      "get_reestricciones",
      "get_TipovalorListadesagregacion"
    ]),
    ...mapActions("usuario/", ["get_usuarios"]),
    ...mapActions("carga/", ["post_cargararchivote"]),
    onEditorReady(quill) {
      quill.format('align', 'justify');
    },
    handleArchivoCargado(item) {    
      this.avanceCualitativoedit.avanceCualitativoTipoValores.filter(p => p.idtipovalor === item )[0].cargado = true;
    },
    onEditorChange({ quill }) {
      quill.getModule('counter').update();
    },
    //procesos avance cualitativo
    closedialog() {
      this.dialogAvancCual = false;
      this.dialogAvancCuan = false;
    },
    editItemavancecualitativo(item) {      
      this.selectedrestricciones = [];
      this.editedIndexcualitativo = this.gavancecualitativo.indexOf(item);
      this.avanceCualitativoedit = Object.assign({}, item);
      this.selectedcualitativo = this.avanceCualitativoedit.idavancecualitativo;
      this.dialogAvancCual = true;
      if (this.avanceCualitativoedit.avancesReestricciones != undefined)
      {
        this.avanceCualitativoedit.avancesReestricciones.forEach(element => { 
          this.selectedrestricciones.push(element.idreestriccion);
        });
      }
      //aqui
    },
    TempClic(){
      this.selectedrestricciones = [];
    },    
    saveCualitativo() {
      if (this.editedIndexcualitativo > -1) {
        this.avanceCualitativoedit.avancesReestricciones = [];
        this.selectedrestricciones.forEach(element => { 
          this.avanceCualitativoedit.avancesReestricciones.push({
            idAvanceCualitativoreestriccion: 0
            , idavancecualitativo: this.avanceCualitativoedit.idavancecualitativo
            , idreestriccion: element})
        });
        Object.assign(this.gavancecualitativo[this.editedIndexcualitativo],this.avanceCualitativoedit);

        let bag = new ErrorBag();
        bag = this.errors;
        if (bag.first('avancecualitativo') !== undefined)
          bag.removeById(bag.first('avancecualitativo').id);

        if (this.$refs.avancecualitativo.quill.root.innerHTML.length > this.$refs.avancecualitativo.quill.options.modules.counter.max && bag.first('avancecualitativo') == undefined) {
          bag.add({
            field: 'avancecualitativo',
          });
        }

        this.selectedrestricciones = [];
        this.MesaggeInfo.mensajeRespuesta = "El avance cualitativo ha sido modificado; los cambios seran permanentes cuando guarde los cambios del formulario";
        this.MesaggeInfo.color = "infovue";
        this.snack = true;
        this.closedialog();
      }
    },
    Addsoportecualitativo() {
      if (this.selectedcualitativo == 0) {
        this.MesaggeInfo.mensajeRespuesta =
          "Seleccione un avance cualitativo para realizar el cargue del soporte";
        this.MesaggeInfo.color = "infovue";
        this.snack = true;
      } else {
        if (this.filecualitativo !== null) {
          for (let i = 0; i < this.filecualitativo.length; i++) {
            let file = this.filecualitativo[i];
            this.soportecualitativo = Object.assign({}, this.soportescuali);
            this.soportecualitativo.nombrearchivo = file.name;
            this.soportecualitativo.tipoarchivo = file.type;
            this.soportecualitativo.idavance = this.selectedcualitativo;
            this.soportecualitativo.finalizado = false;
            this.soportecualitativo.publico = !this.cualitativopublico;
            this.soportecualitativo.archivocompleto = this.imageUrlcualitativo[
              i
            ];
            this.soportecualitativo.idsoporte = 0;
            let Selectrango = this.gavancecualitativo.filter(
              p => p.idavancecualitativo == this.selectedcualitativo
            )[0].rangoperiodo;            
            this.soportecualitativo.rangosoporte = Selectrango;
            this.soportescuali.push(this.soportecualitativo);
          }
          this.imageUrlcualitativo = [];
          this.filecualitativo = [];
        } else {
          this.MesaggeInfo.mensajeRespuesta =
            "Seleccione un archivo para la carga";
          this.MesaggeInfo.color = "infovue";
          this.snack = true;
        }
      }
    },
    onSoporteCualChange() {
      this.imageUrlcualitativo = [];
      let error = false;
      if (this.filecualitativo !== null) {
        for (let i = 0; i < this.filecualitativo.length; i++) {
          if (error === false) {
            let file = this.filecualitativo[i];
            let tipo = file.type.replace("application/", "");
            if (this.tiposarchivo.indexOf(tipo, 0) > 0) {
              if (file.size > this.tamanoarchivo * 1024000) {
                this.MesaggeInfo.mensajeRespuesta =
                  "El tamaño de uno de los archivos supera el límite de carga (" +
                  this.tamanoarchivo +
                  "Mb)";
                this.MesaggeInfo.color = "errorvue";
                this.snack = true;
                error = true;
              } else {
                let actual = this.soportescuali.filter(
                  p =>
                    p.nombrearchivo === file.name &&
                    (p.idavance === this.selectedcualitativo ||
                      p.idavancecualitativo === this.selectedcualitativo)
                )[0];
                if (actual === undefined) {
                  let reader = new FileReader();
                  reader.onload = () => {
                    this.imageUrlcualitativo.push(reader.result);
                  };
                  reader.readAsDataURL(file);
                } else {
                  this.MesaggeInfo.mensajeRespuesta =
                    "Uno de los archivos ya se encuentra relacionado en el reporte";
                  this.MesaggeInfo.color = "errorvue";
                  this.snack = true;
                  error = true;
                }
              }
            } else {
              this.MesaggeInfo.mensajeRespuesta =
                "Uno de los archivos no es compatible con los tipos permitidos";
              this.MesaggeInfo.color = "errorvue";
              this.snack = true;
              error = true;
            }
          }
        }
        if (error === true) {
          this.imageUrlcualitativo = [];
          this.filecualitativo = [];
        }
      }
    },
    deletesoportecualitativo(item) {
      const index = this.soportescuali.indexOf(item);
      if (confirm("Desea eliminar el soporte?")) {
        this.deletesoporteCualitativo.push(item);
        this.soportescuali.splice(index, 1);
      }
    },
    //procesos avance cuantitativo
    editItemavancecuantitativo(item) {
      this.editedIndexcuantitativo = this.gavancecuantitativo.indexOf(item);
      this.avanceCuantitativoedit = Object.assign({}, item);
      if (this.avanceCuantitativoedit.reporte != null)
        if (this.avanceCuantitativoedit.reporte != "") {
          let valreporte = this.avanceCuantitativoedit.reporte;
          this.avanceCuantitativoedit.reporte = valreporte.toString().replace(".", ",");
        }
      this.selectedcuantitativo = this.avanceCuantitativoedit.idavancecuantitativo;

      this.dialogAvancCuan = true;
    },
    saveCuantitativo() {
      if (this.editedIndexcuantitativo > -1) {

        // if (this.avanceCuantitativoedit.reporte !=undefined)
        //   this.avanceCuantitativoedit.reporte = this.avanceCuantitativoedit.reporte.replace(',', '.')
        Object.assign(
          this.gavancecuantitativo[this.editedIndexcuantitativo],
          this.avanceCuantitativoedit
        );
        this.MesaggeInfo.mensajeRespuesta =
          "El avance cuantitativo ha sido modificado; los cambios seran permanentes cuando guarde los cambios del formulario";
        this.MesaggeInfo.color = "infovue";
        this.snack = true;
        this.closedialog();
      }
    },
    Addsoportecuantitativo() {
      if (this.selectedcuantitativo == 0) {
        this.MesaggeInfo.mensajeRespuesta =
          "Seleccione un avance cuantitativo para realizar el cargue del soporte";
        this.MesaggeInfo.color = "infovue";
        this.snack = true;
      } else {
        if (this.filecuantitativo !== null) {
          for (let i = 0; i < this.filecuantitativo.length; i++) {
            let file = this.filecuantitativo[i];
            this.soportecuantitativo = Object.assign({}, this.soportescuanti);
            this.soportecuantitativo.nombrearchivo = file.name;
            this.soportecuantitativo.tipoarchivo = file.type;
            this.soportecuantitativo.idavance = this.selectedcuantitativo;
            this.soportecuantitativo.finalizado = false;
            this.soportecuantitativo.publico = !this.cuantitativopublico;
            this.soportecuantitativo.archivocompleto = this.imageUrlcuantitativo[
              i
            ];
            this.soportecuantitativo.idsoporte = 0;
            let Selectrango = this.avancecuantitativoA.filter(
              p => p.idavancecuantitativo == this.selectedcuantitativo
            )[0].rangoperiodo;            
            this.soportecuantitativo.rangosoporte = Selectrango;
            this.soportescuanti.push(this.soportecuantitativo);
          }
          this.imageUrlcuantitativo = [];
          this.filecuantitativo = [];
        } else {
          this.MesaggeInfo.mensajeRespuesta =
            "Seleccione un archivo para la carga";
          this.MesaggeInfo.color = "infovue";
          this.snack = true;
        }
      }
    },
    onSoporteCuanChange() {
      this.imageUrlcuantitativo = [];
      let error = false;
      if (this.filecuantitativo !== null) {
        for (let i = 0; i < this.filecuantitativo.length; i++) {
          if (error === false) {
            let file = this.filecuantitativo[i];
            let tipo = file.type.replace("application/", "");
            if (this.tiposarchivo.indexOf(tipo, 0) > 0) {
              if (file.size > this.tamanoarchivo * 1024000) {
                this.MesaggeInfo.mensajeRespuesta =
                  "El tamaño de uno de los archivos supera el límite de carga (" +
                  this.tamanoarchivo +
                  "Mb)";
                this.MesaggeInfo.color = "errorvue";
                this.snack = true;
                error = true;
              } else {
                let actual = this.soportescuanti.filter(
                  p =>
                    p.nombrearchivo === file.name &&
                    (p.idavance === this.selectedcuantitativo ||
                      p.idavancecuantitativo === this.selectedcuantitativo)
                )[0];
                if (actual === undefined) {
                  let reader = new FileReader();
                  reader.onload = () => {
                    this.imageUrlcuantitativo.push(reader.result);
                  };
                  reader.readAsDataURL(file);
                } else {
                  this.MesaggeInfo.mensajeRespuesta =
                    "Uno de los archivos ya se encuentra relacionado en el reporte";
                  this.MesaggeInfo.color = "errorvue";
                  this.snack = true;
                  error = true;
                }
              }
            } else {
              this.MesaggeInfo.mensajeRespuesta =
                "Uno de los archivos no es compatible con los tipos permitidos";
              this.MesaggeInfo.color = "errorvue";
              this.snack = true;
              error = true;
            }
          }
        }
        if (error === true) {
          this.imageUrlcuantitativo = [];
          this.filecuantitativo = [];
        }
      }
    },
    deletesoportecuantitativo(item) {
      const index = this.soportescuanti.indexOf(item);
      if (confirm("Desea eliminar el soporte?")) {
        this.deletesoporteCuantitativo.push(item);
        this.soportescuanti.splice(index, 1);
      }
    },
    descargarsoporte(item) {
      if (item.archivocompleto == null) {
        this.downloadsoporte({
          params: {
            idindicador: this.dataindicador.idindicador,
            idsoporte: item.idsoporte
          }
        });
      } else {
        const a = document.createElement("a");
        a.style.display = "none";
        document.body.appendChild(a);
        a.href = item.archivocompleto;
        a.setAttribute("download", item.nombrearchivo);
        a.click();
        window.URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
      }
    },
    //Procesos  Generales
    getusuario() {
      return JSON.parse(unescape(localStorage.usuario));
    },
    errortemporal() {
      this.snack = true;
      this.MesaggeInfo.mensajeRespuesta =
        "Existe una problema en el cargue de los archivos. Intente reducir el número de archivos a guardar.";
      this.MesaggeInfo.color = "warnvue";
      this.loading = false;
    },
    async SaveAvance() {
      this.loading = true;
      let bytes = window.crypto.getRandomValues(new Uint8Array(32));
      const randomBytes = () => (bytes = bytes.slice(1)) && bytes[0];
      let tran = ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
        (c ^ (randomBytes() & (15 >> (c / 4)))).toString(16)
      );
      let bytes2 = window.crypto.getRandomValues(new Uint8Array(32));
      const randomBytes2 = () => (bytes2 = bytes2.slice(1)) && bytes2[0];
      let tran2 = ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
        (c ^ (randomBytes2() & (15 >> (c / 4)))).toString(16)
      );
      if (this.gavancecualitativo.length >= 1) {
        if (this.soportecualitativo != null) {
          // this.gavancecualitativo[0].soporte = this.gsoportescualitativos;
        } else {
          this.gavancecualitativo[0].soporte = null;
        }
        this.gavancecualitativo[0].soportedelte = this.deletesoporteCualitativo;
      }

      if (this.gavancecuantitativo.length >= 1) {
        //Colocamos en cero el reporte del reporte para los avances cuya meta son cero
        this.gavancecuantitativo.forEach(element => {
          // toda meta en cero era castigada con el reporte en cero, se bloquea esta instruccion por ajustes en castigos
          // if (element.idmetaNavigation.valor == 0)
          //   element.reporte = 0
          if (element.reporte != null)
            if (element.reporte.length > 0)
              element.reporte = parseFloat(element.reporte.replace(",", "."))
        });

        if (this.soportecuantitativo != null) {
          //  this.gavancecuantitativo[0].soporte = this.gsoportescuantitativos;
        } else {
          this.gavancecuantitativo[0].soporte = null;
        }
        this.gavancecuantitativo[0].soportedelte = this.deletesoporteCuantitativo;
      }
      this.dataindicador.transaccioncualitativo = tran;
      this.dataindicador.transaccioncuantitativo = tran2;
      let errorcarga = false;
      if (this.gavancecualitativo.length >= 1) {
        if (this.soportecualitativo != null) {
          await this.post_cargararchivote({
            archivo: this.soportescuali,
            idtransaccion: tran,
            tamanopaquete: this.tamanopaquete
          }).then(function () { });
          errorcarga = this.gerrorcarga;
        }
      }
      if (errorcarga === false) {
        if (this.gavancecuantitativo.length >= 1) {
          if (this.soportecuantitativo != null) {
            await this.post_cargararchivote({
              archivo: this.soportescuanti,
              idtransaccion: tran2,
              tamanopaquete: this.tamanopaquete
            }).then(function () { });
            errorcarga = this.gerrorcarga;
          }
        }
        if (errorcarga === false) {
          this.dataindicador.avanceCualitativos = this.gavancecualitativo;
          this.dataindicador.avanceCuantitativos = this.gavancecuantitativo;

          if (this.estadoRegistro == 3) {
            if (this.dataindicador.fichaaprobada == null) {
              this.snack = true;
              this.MesaggeInfo.mensajeRespuesta =
                "debe aprobar o rechazar el indicador";
              this.MesaggeInfo.color = "infovue";
              this.loading = false;
              return;
            }
            if (this.dataindicador.comentarioflujo == null) {
              this.snack = true;
              this.MesaggeInfo.mensajeRespuesta =
                "El comentario del indicador no puede estar vacio";
              this.MesaggeInfo.color = "infovue";
              this.loading = false;
              return;
            }
          }
          
          this.putavance({
            data: this.dataindicador
          });
          this.deletesoporteCualitativo = [];
          this.deletesoporteCuantitativo = [];
        } else {
          this.errortemporal();
        }
      } else {
        this.errortemporal();
      }
    },
    ValidarDesagregaciones(){
          // validamos que se haya gestionado el documento principal de la desagregación 
          if(this.tiposValores != undefined ) {
            if (this.tiposValores.length > 0)
            {
              let Periodosingestion = ''
              let TPPrincipal = this.tiposValores.filter(p => p.principal === true)[0]
              let singestionar = true;
              if (this.gavancecualitativo.length > 0)
              {
                
                let AvancesGestionados = this.gavancecualitativo.filter(p => p.mostrardesagregaciones === true);
                              
                if (AvancesGestionados.length > 0)
                {
                  AvancesGestionados.forEach((element) => {
                    let elementocargado = element.avanceCualitativoTipoValores.filter(p => p.idtipovalor === TPPrincipal.id)[0]
                    
                    if (elementocargado != null)
                      if (elementocargado.cargado == false && element.descripcion != null)
                      {
                        Periodosingestion = element.rangoperiodo;
                        if (element.descripcion.length > 0)
                          singestionar = false
                      }
                  });
                }
              }
              if (singestionar == false){
                this.snack = true;
                this.MesaggeInfo.mensajeRespuesta = "El tipo valor " + TPPrincipal.nombre + ' es obligatorio y se debe diligenciar para el periodo ' + Periodosingestion ;
                this.MesaggeInfo.color = "warnvue";
                this.loading = false;
                return false;
              }
            }
          }
          return true;
    },
    FinalizarAvance() {
      var Errores = "";
      this.ValidarRevisionComentario()
      //agregamos comentario a esta linea ya que los funcionales solicitan validar las desagregaciones de forma manual
      //if (this.ValidarDesagregaciones())
      this.$validator.validateAll().then(result => {
        if (result && this.$validator.errors.items.length == 0) {
          this.dataindicador.finalizar = true;
          this.SaveAvance();
          this.marcarfinalizado();
          return;
        }
        console.log(this.$validator);
        this.$validator.errors.items.forEach((element) => {
          Errores = Errores + "( " + element.msg + " ), ";
        });
        this.snack = true;
        this.MesaggeInfo.mensajeRespuesta =
          "la validación del formulario contiene errores" + Errores;
        this.MesaggeInfo.color = "infovue";
      });
    },
    ValidarRevisionComentario() {
      let bag = new ErrorBag();
      bag = this.errors;
      if (bag.first('revisioncomentario') !== undefined)
        bag.removeById(bag.first('revisioncomentario').id);

      if (this.$refs.revisioncomentario.quill.root.innerHTML.length > this.$refs.revisioncomentario.quill.options.modules.counter.max && bag.first('revisioncomentario') == undefined) {
        bag.add({
          field: 'revisioncomentario',
          msg: 'está superando el límite de caracteres'
        });
      }
    },
    readcontrol(control) {
      if (this.estadocampos.length > 0) {
        let responseread = this.estadocampos.find(function (element) {
          if (element.nombre == control) {
            return element;
          }
        });
        if (responseread == null) return true;
        else return responseread.lectura;
      }
    },
    controlrevision(control) {
      let mostrar1 = this.showcontrol(control);
      let mostrar = false;
      if (mostrar1 !== undefined) {
        mostrar = this.buttonguardarestado === false && mostrar1.visible === true;
      }
      return mostrar;
    },
    showcontrol(control) {
      if (this.estadocampos.length > 0) {
        let responsefound = this.estadocampos.find(function (element) {
          if (element.nombre == control) {
            return element.visible;
          }
        });
        if (responsefound == null) return false;
        else return responsefound;
      }
    },
    readcontrolindicador(control) {
      if (this.estadocamposindicador.length > 0) {
        let responseread = this.estadocamposindicador.find(function (element) {
          if (element.nombre == control) {
            return element;
          }
        });
        if (responseread == null) return true;
        else return responseread.lectura;
      }
    },
    showcontrolindicador(control) {
      if (this.estadocamposindicador.length > 0) {
        let responsefound = this.estadocamposindicador.find(function (element) {
          if (element.nombre == control) {
            return element.visible;
          }
        });
        return responsefound;
      }
    },
    functionalert() {
      if (this.buttontext == "cerrar") {
        this.snack = false;
      }
      if (this.buttontext == "aceptar") {
        this.buttontext == "cerrar";
        this.snack = false;
        this.timeoutsnak = 4000;
        let ruta = "/tareas";
        this.$router.push(ruta);
      }
    },
    cambiarenter(cadena) {
      if (cadena !== null) {
        let otro = cadena.replace(/\n/g, "<br>");

        return otro;
      }
    },
    usuario(idusuario) {
      if (this.gusuarios !== undefined)
        return this.gusuarios.filter(p => p.idusuario === idusuario)[0].login;
      else return "Anonimo";
    },
    formato(value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY (HH:m)");
      }
    },
    formatobasic(value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY");
      }
    },
    marcarfinalizado() {
      // Estas lineas de codigo se utilizan para generar un temporal del indicador finalizado
      //================================================
      let ahora = new Date();
      let ahorafilter = new Date();
      ahorafilter.setMinutes(ahorafilter.getMinutes() - this.timewait);
      ahorafilter = new Date(ahorafilter);
      this.AvanceFiltrado.push({
        indicador: this.dataindicador.idindicador,
        fecha: ahora
      });
      localStorage.setItem(
        "AvanceFiltrado",
        JSON.stringify(this.AvanceFiltrado)
      );
      //===================================================
    },
    EliminarFinalizado() {
      // Estas lineas de codigo se utilizan para generar un temporal del indicador finalizado
      //================================================
      this.AvanceFiltrado.forEach(element => {
        if (this.dataindicador.idindicador == element.indicador) {
          const index = this.AvanceFiltrado.indexOf(element);
          this.AvanceFiltrado.splice(index, 1);
        }
      });
      localStorage.setItem(
        "AvanceFiltrado",
        JSON.stringify(this.AvanceFiltrado)
      );
      //===================================================
    },
    getIDfinalizados() {
      let vfiltro = localStorage.AvanceFiltrado;
      if (vfiltro !== undefined) {
        this.AvanceFiltrado = JSON.parse(unescape(vfiltro));
      }
      //validamos que no hayan dado F5 despues de haber dado finalizar
      if (this.AvanceFiltrado != undefined) {
        let GetCurrentIndicador = this.AvanceFiltrado.filter(
          X => X.indicador == this.idindicador
        );
        if (GetCurrentIndicador != undefined) {
          if (GetCurrentIndicador.length > 0) {
            let mensajealerta =
              "El indicador " +
              this.idindicador +
              " ya fue finalizado y esta siendo procesado";
            this.snack = true;
            this.MesaggeInfo.mensajeRespuesta = mensajealerta;
            this.MesaggeInfo.color = "infovue";
            let ruta = "/tareas";
            this.$router.push(ruta);
          }
        }
      }
    },
    MarcarExclude(item) {
      if (item.marcarExcluir)
        item.idestado = 7
      else
        item.idestado = 3
    },
    changestatesoporte(item) {
      this.getcambiarestadosoporte({ params: { idsoporte: item.idsoporte } });
      if (item.publico == false)
        item.publico = true;
      else
        item.publico = false;
    }
  },
  created() {
    this.get_usuarios();
    let user = this.getusuario();
    if (user != undefined)
      this.currentRol = user.usuarioRol.map(item => { return item.idrol });

    let auten = user.token.replace("Bearer ", "");
    this.$aes.setKey(auten);
    let temporal = this.$route.params.idindicador.replace(/AbcYq/g, "/");
    temporal = temporal.replace(/qYcbA/g, "+");
    temporal = this.$aes.decrypt(temporal);
    temporal = temporal.substring(4);
    temporal = temporal.substring(0, temporal.length - 4);
    temporal = this.$aes.decrypt(temporal);
    this.idindicador = temporal;
    this.get_configuraciones();
    this.getIDfinalizados();
    this.Getperiodicidad();
    this.Gettipoacumulacion();
    this.get_unidades();
    this.get_reestricciones();
    this.Indicador_avances({
      params: {
        idindicador: this.idindicador
      }
    });
  },
  computed: {
    ...mapGetters([
      "gavancecualitativo",
      "gavancecualitativohistoric",
      "gindicadoravances",
      "gavancecuantitativo",
      "gavancecuantitativohistoric",
      "gsoportescuantitativos",
      "gsoportescualitativos",
      "gsoportehito",
      "gcampos",
      "gcampossecundary",
      "gtareascerradas",
      "gconfiguraciones",
      "gsoportescuantitativosaprobados",
      "gsoportescualitativosaprobados",
      "gsoportehitoaprobados",
      "gperiodicidad",
      "gtipoacumulacion",
      "gunidades",
      "greestricciones",
      "gTipovalorListadesagregacion"
    ]),
    ...mapGetters("mensaje", ["ginformation", "gnodata"]),
    ...mapGetters("usuario", ["gusuario", "gusuarios"]),
    ...mapGetters("carga", ["gerrorcarga"]),

    showHeadersSCunatitativo() {
      return this.headersoportecuantitativo.filter(s => {
        if (s.value == 'publico') {
          if (this.currentRol.findIndex(x => x == 3) >= 0)
            return s;
        }
        else
          return s;
      });
    }
  },

  watch: {
    
    gindicadoravances: function () {
      this.dataindicador = this.gindicadoravances;
    },
    //get_TipovalorListadesagregacion
    gTipovalorListadesagregacion: function () {  
      if (this.gTipovalorListadesagregacion.length > 0 ) {
        this.TipovalorListadesagregacion = this.gTipovalorListadesagregacion;      
        //distinct idtipovalor,nombretipovalor,estado,estadocarga
        this.TipovalorListadesagregacion = this.TipovalorListadesagregacion.filter((valor, indice, self) => {
          return self.findIndex(v => v.idtipovalor === valor.idtipovalor) === indice;
        });      
        //muestra los datos en alert
        //alert(JSON.stringify(this.TipovalorListadesagregacion));
        //limpiar tiposValores
        this.tiposValores = [];
        //cargar los tiposValores
        this.TipovalorListadesagregacion.forEach(element => {
          this.tiposValores.push({ id: element.idtipovalor, nombre: element.nombretipovalor,estado:element.estadocarga,principal:false });
        });
        //asigna al primer registro de tiposValores principal = true
        if (this.tiposValores.length > 0)
          this.tiposValores[0].principal = true;  
          this.panel = 0;
      }
    },
    dataindicador: function (val) {
      this.estadoRegistro = val.idestadoavance;
      this.get_camposestadosecundary({
        params: {
          idtabla: "indicador",
          idestado: this.estadoRegistro
        }
      }),
        this.get_historicotareas({
          params: {
            idtabla: "4",
            idelemento: val.idindicador
          }
        });
        this.getavancecualitativo({
          params: {
            idindicador: val.idindicador
          }
        }),

        //call get_TipovalorListadesagregacion 
        this.get_TipovalorListadesagregacion({
          params: {
            idindicador: val.idindicador,
            principal: false
          }
        }),        

        this.getcualitativohistorico({
          params: {
            idindicador: val.idindicador
          }
        }),
        this.getavancecuantitativo({
          params: {
            idindicador: val.idindicador
          }
        }),
        this.getcuantitativohistorico({
          params: {
            idindicador: val.idindicador
          }
        }),
        this.getsoportescuantitativos({
          params: {
            idindicador: val.idindicador
          }
        }),
        this.getsoportescualitativos({
          params: {
            idindicador: val.idindicador
          }
        }),
        this.getsoportesHitosbyind({
          params: {
            idindicador: val.idindicador
          }
        });
        this.usuarioregistrado = this.getusuario();
        // Proceso que establece el estado de los botones

        if (val.idusuarioresponsable !== null) {
          if (val.idusuarioresponsable == this.usuarioregistrado.idusuario) {
            this.userautenticado = true;
          }
        }

        if (val.idrolresponsable !== null && this.userautenticado == false) {
          this.usuarioregistrado.usuarioRol.forEach(element => {
            if (element.idrol == val.idrolresponsable) {
              this.userautenticado = true;
            }
          });
        if (val.idrolresponsable != 3)          
          if (this.usuarioregistrado.identidad != val.identidad)
            this.userautenticado = false;
        }

        if (this.userautenticado) {
          this.buttonfinalizarestado = false;
          this.buttonguardarestado = false;
        }
        this.PeriodicidadSelect = this.gperiodicidad.filter(
          p => p.idperiodicidad === this.dataindicador.idperiodicidadactualizacion
        )[0].nombre

        this.Tipoacumulacionselect =  this.gtipoacumulacion.filter(
          p => p.idtipoacumulacion === this.dataindicador.idtipoacumulacion
        )[0].nombre

        this.SelectUnidaddemedida = this.gunidades.filter(
          p => p.idunidad === this.dataindicador.idunidad
        )[0].nombre

    },
    ginformation() {
      if (this.loading) {
        if (this.ginformation.idGenerado == "1") {
          //esta linea es un guardado existoso
          this.soportecualitativo = null;
          this.soportecuantitativo = null;
          this.getsoportescuantitativos({
            params: { idindicador: this.dataindicador.idindicador }
          });
          this.getsoportescualitativos({
            params: { idindicador: this.dataindicador.idindicador }
          });
          this.getsoportesHitosbyind({
            params: {
              idindicador: this.dataindicador.idindicador
            }
          });
        }
        if (this.dataindicador.finalizar) {
          this.buttonguardarestado = true;
          this.buttonfinalizarestado = true;
          this.buttontext = "aceptar";
          this.timeoutsnak = 0;
          this.snack = true;
          this.MesaggeInfo.mensajeRespuesta =
            "El avance ha sido registrado correctamente, presione aceptar para continuar";
          this.MesaggeInfo.color = "infovue";
        } else {
          this.EliminarFinalizado();
          this.dataindicador.finalizar = false;
          this.MesaggeInfo = this.ginformation;
          this.snack = true;
          //este console por favor dejarlo, es para que el usuario tenga en consola los posibles mensajes por si no alcanza a leerlo
          console.log(this.MesaggeInfo.mensajeRespuesta);
        }
        this.loading = false;
        store.dispatch("mensaje/set_reset");
      }
    },
    gavancecuantitativo: function () {
      this.avancecuantitativoA = this.gavancecuantitativo;
    },
    gavancecualitativo: function () {

    },
    estadoRegistro: function () {
      this.get_camposestado({
        params: {
          idtabla: "Avance",
          idestado: this.estadoRegistro
        }
      });
    },
    gavancecuantitativohistoric: function () {
      this.ancecuantitativohistoricA = this.gavancecuantitativohistoric;
    },
    gcampos() {
      this.estadocampos = this.gcampos;
    },
    gconfiguraciones() {
      this.tiposarchivo = this.gconfiguraciones.filter(
        p => p.codigo === "TiposArchivo"
      )[0].valor;
      this.tamanoarchivo = this.gconfiguraciones.filter(
        p => p.codigo === "TamanoArchivo"
      )[0].valor;
      this.tamanopaquete = this.gconfiguraciones.filter(
        p => p.codigo === "TamanoPaquete"
      )[0].valor;
      let GetConfigtime = this.gconfiguraciones.filter(
        X => X.codigo == "TiempoEspera"
      )[0];
      if (GetConfigtime != undefined) {
        this.timewait = GetConfigtime.valor;
      }
    },
    gsoportescualitativos() {
      this.soportescuali = this.gsoportescualitativos;
    },
    gsoportescuantitativos() {
      this.soportescuanti = this.gsoportescuantitativos;
    },
    selectedrestricciones() {
      this.shownewrestriccion = false;
      let SelectUnica = false;
      this.selectedrestricciones.forEach(element => { 
        let getresticcion = this.greestricciones.filter( X => X.idreestriccion == element)[0];
        if (getresticcion != null){

          if (getresticcion.requieredescripcion == true)
            this.shownewrestriccion = true;

          if (getresticcion.unico == true)
            SelectUnica = true;          
        }
      });
      if (this.shownewrestriccion == false)
        this.avanceCualitativoedit.nuevareestriccion = "";
      if (SelectUnica == true && this.selectedrestricciones.length >=2 ){
        this.selectedrestricciones = [];
        this.selectedrestricciones.push(this.greestricciones.filter( X => X.unico == true)[0].idreestriccion);
      }
        
    }
  }
};
</script>
<style>

</style>